<template>
  <v-card class="my-1" elevation="0">
    <v-card-title>
      <h5>Dispersão — Sa × SFP × PSFP</h5>
    </v-card-title>
    <div class="caption grey--text px-4">
      Eixo X: Sa (volume) | Eixo Y: SFP | Tamanho: PSFP (%) | Cor: faixas de
      PSFP
    </div>

    <div
      v-if="loading"
      class="d-flex align-center justify-center"
      style="height: 300px;"
    >
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>

    <v-card-text v-else>
      <highcharts :options="chartOptions" :deepCopyOnUpdate="false" />
    </v-card-text>
  </v-card>
</template>

<script>
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
HighchartsMore(Highcharts);
export default {
  name: "DashboardIsfpPsfpDispersaoDetalhamento",
  props: {
    dispersao: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  computed: {
    chartOptions() {
      return {
        chart: { type: "bubble", height: 500, zoomType: "xy" },
        credits: { enabled: false },
        title: { text: null },
        legend: { enabled: true },
        xAxis: {
          type: "logarithmic",
          title: { text: "Sa (Escala Logarítmica)" },
          labels: { style: { fontSize: "11px" } },
        },
        yAxis: {
          type: "logarithmic",
          title: { text: "SFP (Escala Logarítmica)" },
          labels: { style: { fontSize: "11px" } },
        },
        tooltip: {
          useHTML: true,
          formatter() {
            return `
              <b> ${this.point.indice_categoria} - ${
              this.point.codigos_servico
            } — ${this.point.descricao_por_indice}</b><br/>
              Sa: ${this.x}<br/>
              SFP: ${this.y}<br/>
              PSFP: ${
                this.point.psfp != null
                  ? Number(this.point.psfp)
                      .toFixed(2)
                      .replace(".", ",") + "%"
                  : "Sem dados"
              }
            `;
          },
        },
        plotOptions: {
          bubble: {
            minSize: 8,
            maxSize: 50,
          },
        },
        series: this.series,
        lang: { noData: "Sem dados para exibição" },
      };
    },
    series() {
      const faixas = {
        ate_1: { label: "<= 1%", color: "#4CAF50" },
        de_1_a_5: { label: "> 1% a 5%", color: "#8BC34A" },
        de_5_a_10: { label: "> 5% a 10%", color: "#FFC107" },
        de_10_a_20: { label: "> 10% a 20%", color: "#FF9800" },
        acima_20: { label: "> 20%", color: "#F44336" },
      };
      const grupos = {};
      Object.entries(faixas).forEach(([chave, info]) => {
        grupos[chave] = {
          name: info.label,
          color: info.color,
          data: [],
        };
      });
      this.dispersao.forEach((item) => {
        const chave = item.faixa_chave ?? "ate_1";
        if (!grupos[chave]) return;
        grupos[chave].data.push({
          x: item.sa,
          y: item.sfp,
          z: Math.max(item.psfp, 1),
          psfp: item.psfp,
          indice_categoria: item.indice_categoria,
          codigos_servico: item.codigos_servico,
          descricao_por_indice: item.descricao_por_indice,
        });
      });
      return Object.values(grupos).filter((g) => g.data.length > 0);
    },
  },
};
</script>
